import React from "react";
import { FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import "../Css/TopBar.css";

const TopBar = () => {
  return (
    <div className="topbar">
      <div className="topbar-container">

        {/* LEFT */}
        <div className="topbar-left">
          <FaPhoneAlt className="icon" />
          <a href="tel:+918849189845" className="topbar-link">
            +91-8849189845
          </a>
        </div>

        {/* RIGHT */}
        <div className="topbar-right">
          <div className="location">
            <FaMapMarkerAlt className="icon" />
            <a
              href="https://maps.app.goo.gl/zzcNYPC3EBMPBHsj8"
              target="_blank"
              rel="noopener noreferrer"
              className="topbar-link"
            >
              Vasna Road
            </a>
          </div>
        </div>

      </div>
    </div>
  );
};

export default TopBar;
